import { env } from "@/app/config/env";
import { compareVersions, type MinimumVersion } from "@shared/contracts";

/**
 * IS THIS BUILD NEW ENOUGH? — the judgement that makes "an app you cannot recall" survivable.
 *
 * Without it the failure mode is a parse error on an unrelated screen, weeks later, from a
 * user who cannot say which build they are on.
 *
 * WHAT USED TO BE HERE AND IS NOT ANY MORE: the fetch. This file owned a round trip to
 * `/v1/meta/minimum-version`, its own six-hour clock, and its own "unreachable is not too
 * old" rule. All three moved into the client manifest (`app/config/manifest.ts` for the
 * values and the cache, `app/lib/manifest.ts` for the asking), because the floor is one
 * field of the answer to "what should this build do?" and two things answering that question
 * can disagree about the same build. The service still serves the old endpoint, for builds
 * already installed; this app no longer calls it.
 *
 * What is left is pure: a floor in, a verdict out. It keeps its own file because it is the
 * one piece of this that a screen depends on.
 */
export { compareVersions };

export type VersionVerdict = "ok" | "update-recommended" | "update-required";

/**
 * The permissive default floor is `0.0.0`, so a build that has never reached the service —
 * or reached it and could not understand the answer — is judged against a floor nothing is
 * below. An unreachable launch can therefore never become a wall. That was true before the
 * fetch moved and is the property most worth not losing in the move.
 */
export function versionVerdict(floor: MinimumVersion): VersionVerdict {
  if (compareVersions(env.version, floor.minimum) < 0) return "update-required";
  if (compareVersions(env.version, floor.recommended) < 0) return "update-recommended";
  return "ok";
}
